import { SpravciOsobnichUdaju } from './spravciOsobnichUdaju';
import { KodyCV } from './kodyCV';
import { Logotypy } from './logotypy';
import { VyrobekNd } from './vyrobekNd';
import { VyrobekVoz } from './vyrobekVoz';

export const menu = {
	name: 'CiselnikKoncernove',
	list: [
		{ name: 'KodyCV', route: KodyCV.name },
		{ name: 'Logotypy', route: Logotypy.name },
		{ name: 'VyrobekNd', route: VyrobekNd.name },
		{ name: 'VyrobekVoz', route: VyrobekVoz.name },
		{ name: 'ZpracovOsDat', route: SpravciOsobnichUdaju.name },
	],
};
